import { render, staticRenderFns } from "./CarteiraIdentidade.vue?vue&type=template&id=1a9f8cce&"
import script from "./CarteiraIdentidade.vue?vue&type=script&lang=js&"
export * from "./CarteiraIdentidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports